import { render } from "./MobilePreview.vue?vue&type=template&id=8694e2aa&scoped=true"
import script from "./MobilePreview.vue?vue&type=script&lang=js"
export * from "./MobilePreview.vue?vue&type=script&lang=js"

import "./MobilePreview.vue?vue&type=style&index=0&id=8694e2aa&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8694e2aa"]])

export default __exports__